import styled, { css } from "styled-components";

export const ButtonStyled = styled.button`
  display: flex;
  justify-content: center;
  flex-direction: ${({ direction }) => direction};
  align-items: center;
  gap: 5px;
  border-radius: 4px;
  transition: all 0.2s;

  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-family: Rubik;
  cursor: pointer;

  ${({ size }) => {
    switch (size) {
      case "large":
        return css`
          font-size: 16px;
          padding: 11px 17px;
        `;
      case "medium":
        return css`
          font-size: 14px;
          padding: 11px 17px;
        `;
      case "small":
        return css`
          font-size: 12px;
          padding: 7px 10px;
        `;
      default:
        return css`
          font-size: 14px;
          padding: 11px 17px;
        `;
    }
  }}

  ${({ variant, dark, light }) => {
    switch (variant) {
      case "primary":
        return css`
          background-color: #36f99f;
          color: #000000;

          &:hover {
            background-color: #27dd8b;
          }
        `;
      case "secondary":
        return css`
          border: 1px solid #7a89f4;
          background-color: transparent;
          color: ${dark ? "#dce0fc" : "#252528"};

          &:hover {
            color: #252528;
            background-color: ${light ? "#c9cffe" : "#dce0fc"};
            border: 1px solid #dce0fc;
          }
        `;
      case "tertiary":
        return css`
          border: 1px solid #7a89f4;
          background-color: #eff0fa;
          color: #1e22ff;

          &:hover {
            color: #ffffff;
            background-color: #7a89f4;
          }
        `;
      case "warning":
        return css`
          background-color: #fff1ca;
          color: #000000;

          &:hover {
            background-color: #ffc82c;
          }
        `;
      case "link":
        return css`
          font-size: 12px;
          padding: 0;
          border: none;
          background: none;
          text-decoration: underline;
          color: #7a89f4;

          &:hover {
            color: #1e22ff;
          }
        `;
      default:
        return css`
          border: 1px solid #7a89f4;
          background-color: transparent;
          color: ${dark ? "#dce0fc" : "#252528"};

          &:hover {
            background-color: ${dark ? "#dce0fc" : "#7a89f4"};
          }
        `;
    }
  }};

  &:disabled {
    color: #abb4f4;
    border: 1px solid rgb(122, 137, 244);
    background-color: #dce0fc;
    cursor: not-allowed;
    &:hover {
    }
  }
`;
